import { html } from 'lit-element';
import { classMap } from 'lit-html/directives/class-map';

import { SimpleLitElement } from '@elab/components';
import connect from '@elab/core/store/connect';
import { actions as authActions } from '@elab/core/store/auth';
import { actions as uiActions } from '@elab/core/store/ui';

/**
 * Component is used to render the logout button of the My Account navigation.
 * It is visible only on desktop and writes it's data to 'ui.accountNav' store.
 *
 * @author Roberto Schiavone
 * @attr {String} [url]
 * @attr {String} [title]
 * @attr {String} [class-modifier] - custom class modifier
 * HTML Structure
 * <e2-my-account-logout> url="/my-account-navigation.html" title="Logout" class-modifier="vip-personalization"></e2-my-account-logout>
 * */

class MyAccountNavigationLogout extends SimpleLitElement {
    static get properties() {
        return {
            url: { type: String },
            title: { type: String },
            classModifier: {
                type: String,
                attribute: 'class-modifier',
            },
            iconClassName: {
                type: String,
                attribute: 'icon-class-name',
            },
        };
    }

    constructor() {
        super();
        this.classModifier = '';
    }

    handleClick() {
        this.dispatchEvent(new CustomEvent('account-navigation-logout'));
    }

    firstUpdated() {
        setTimeout(this.onComponentReady.bind(this), 0);
    }

    onComponentReady() {
        this.dispatchEvent(
            new CustomEvent('account-navigation-add', {
                detail: {
                    title: this.title,
                    eventName: 'account-navigation-logout',
                    redirectUrl: this.url,
                },
            }),
        );
    }

    getIconClass() {
        return classMap({
            'my-account-navigation__link-icon': true,
            [`my-account-navigation__link-icon--${this.classModifier}`]: this.classModifier !== '',
        });
    }

    getAccountClassName() {
        return classMap({
            'my-account-navigation__link': true,
            'my-account-navigation__link--primary': true,
            'my-account-navigation__link--logout': true,
            [`my-account-navigation__link--${this.classModifier}`]: this.classModifier !== '',
        });
    }

    render() {
        return html`
            <button
                type="button"
                @click="${this.handleClick}"
                class="${this.getAccountClassName()}"
            >
                <span class="${this.getIconClass()}">
                    <i class="${this.iconClassName}"></i>
                </span>
                <h5 class="my-account-navigation__title">
                    ${this.title}
                </h5>
                <i class="my-account-navigation__arrow my-account-navigation__arrow--right"></i>
            </button>
        `;
    }
}

const mapDispatchToEvents = (dispatch, ctx) => ({
    'account-navigation-logout': () => dispatch(authActions.doLogout(ctx.url)),
    'account-navigation-add': ({ detail }) => dispatch(uiActions.addAccountNavigation(detail)),
});

export default () =>
    customElements.define(
        'e2-my-account-navigation-logout',
        connect(null, mapDispatchToEvents)(MyAccountNavigationLogout),
    );
